import type { ReissueStatusType } from '../../PrescriptionPad';
import { PrescriptionItemAlertType } from '../PrescriptionItemEditor.types';

type AlertTypeProps = {
  reissueStatus?: Partial<ReissueStatusType>;
  errorMessage: { title: string; description: string } | null;
  hasActiveCancelAlert: boolean;
};

export const useAlertType = ({
  reissueStatus,
  errorMessage,
  hasActiveCancelAlert
}: AlertTypeProps): PrescriptionItemAlertType | null => {
  const availabilityAlertType: PrescriptionItemAlertType | null = !reissueStatus
    ? null
    : (
        [
          [reissueStatus.isActive === false, PrescriptionItemAlertType.INACTIVE],
          [reissueStatus.isDiscontinued, PrescriptionItemAlertType.DISCONTINUED],
          [reissueStatus.isOutOfStock, PrescriptionItemAlertType.OUT_OF_STOCK],
          [reissueStatus.isUnavailable, PrescriptionItemAlertType.UNAVAILABLE]
        ] as [boolean | undefined, PrescriptionItemAlertType][]
      ).find(([condition]) => Boolean(condition))?.[1] ?? null;

  if (errorMessage) {
    return PrescriptionItemAlertType.ERROR;
  }

  if (hasActiveCancelAlert) {
    return PrescriptionItemAlertType.CANCEL;
  }

  if (availabilityAlertType) {
    return availabilityAlertType;
  }

  if (reissueStatus?.isReissued) {
    return PrescriptionItemAlertType.REISSUE;
  }

  return null;
};
